import { render, staticRenderFns } from "./GoogleAuth.vue?vue&type=template&id=8a7fd0b8"
import script from "./GoogleAuth.vue?vue&type=script&lang=js"
export * from "./GoogleAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports